// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2ZCqT","list":"BalanceDue_list__1vL6I","listRow":"BalanceDue_listRow__BohJF","total":"BalanceDue_total__1JdLs"};